import { render } from "./AssistantWork.vue?vue&type=template&id=67075804&scoped=true"
import script from "./AssistantWork.vue?vue&type=script&lang=js"
export * from "./AssistantWork.vue?vue&type=script&lang=js"

import "./AssistantWork.vue?vue&type=style&index=0&id=67075804&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67075804"]])

export default __exports__